import {Injectable} from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {DTFService} from '../../dtf.service';
import { AuthTokenDetails } from '../../shared/models/authTokenDetails';
import { BehaviorSubject } from 'rxjs';
import { ContractNumberRequest } from '../../shared/models/contractNumberResponse';
import { AddressRequest } from '../../shared/models/AddressRequest';
import { throwError } from 'rxjs';



@Injectable({ providedIn: 'root' })

export class AuthorizationService {
  isAuth = '';
  isAdminAuth='';
  istoken = '';
  errorMessage = '';
  
  public _isAuth = new BehaviorSubject<boolean>(false); // Used to check if user is Authenticated
  cast = this._isAuth.asObservable();
  public _isAdminAuth = new BehaviorSubject<boolean>(false); // Used to check if user is Authenticated
  castadmin = this._isAdminAuth.asObservable();
  public _contractList: BehaviorSubject<ContractNumberRequest[]> = new BehaviorSubject<ContractNumberRequest[]>([]);
  cast2 = this._contractList.asObservable();
  public _isErrorMessage = new BehaviorSubject<string>(''); // Used to check if user is Authenticated
  cast3 = this._isErrorMessage.asObservable();
  public _terminationDate = new BehaviorSubject<string>(''); // Used to check if user is Authenticated
  cast4 = this._terminationDate.asObservable();
  public _address: BehaviorSubject<AddressRequest[]> = new BehaviorSubject<AddressRequest[]>([]);
  cast5 = this._address.asObservable();

    constructor(private http: HttpClient, private dtfService: DTFService) {}

    getAuthToken(): Observable<AuthTokenDetails> {
      let username = '';
      if(sessionStorage.getItem('username')){
          username = sessionStorage.getItem('username');
      }
      this.dtfService.convertText(username.toLowerCase());
      return this.http.post<AuthTokenDetails>(this.dtfService.getAuthUrl(),
          {"username":username,"password":this.dtfService.conversionEncryptOutput},
          {headers: this.dtfService.getHttpHeaders()});
    }

    getLogin(request: any) {
      return this.http.post<any>(this.dtfService.getLogin(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    login(request: any) {
      return this.http.post<any>(this.dtfService.login(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    getPreLogin(request: any) {
      return this.http.post<any>(this.dtfService.getPreLogin(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    emailVerificationForLogin(request: any) {
      return this.http.post<any>(this.dtfService.emailVerificationForLogin(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    decryptFawToken(request: any) {
      return this.http.post<any>(this.dtfService.decryptFawToken(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    

    getDashBoardDetails(request: any){
      return this.http.post<any>(this.dtfService.getDashBoardDetails(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    getAccountDetailsListByUserId(request: any){
      return this.http.post<any>(this.dtfService.getAccountDetailsListByUserId(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    getTerminatedAccounts(request: any){
      return this.http.post<any>(this.dtfService.getTerminatedAccounts(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    getMaturedAccounts(request: any){
      return this.http.post<any>(this.dtfService.getMaturedAccounts(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    getAmort(request: any){
      return this.http.post<any>(this.dtfService.getAmort(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    getInvoice(request: any){
      return this.http.post<any>(this.dtfService.getInvoice(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    getManageYourProfile(request: any){
      return this.http.post<any>(this.dtfService.getManageYourProfile(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
  
    updateAndSaveNewPassword(request: any){
      return this.http.post<any>(this.dtfService.updateAndSaveNewPassword(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    updateAndSaveNewAdminPassword(request: any){
      return this.http.post<any>(this.dtfService.updateAndSaveNewAdminPassword(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    getAdminUser(request: any){
      return this.http.post<any>(this.dtfService.getAdminUser(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    adminLogin(request: any){
      return this.http.post<any>(this.dtfService.adminLogin(), request,{ headers: this.dtfService.getHttpHeaders() });
    } 

    prepareForAdminResetStepOne(request: any){
      return this.http.post<any>(this.dtfService.prepareForAdminResetStepOne(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    fetchAdminList(request: any){
      return this.http.post<any>(this.dtfService.fetchAdminList(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    fetchUserList(request: any){
      return this.http.post<any>(this.dtfService.fetchUserList(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    unlockUser(request: any){
      return this.http.post<any>(this.dtfService.unlockUser(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    updateEmail(request: any){
      return this.http.post<any>(this.dtfService.updateEmail(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    inactivateUser(request: any){
      return this.http.post<any>(this.dtfService.inactivateUser(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    reactivateUser(request: any){
      return this.http.post<any>(this.dtfService.reactivateUser(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    saveAdminDetails(request: any){
      return this.http.post<any>(this.dtfService.saveAdminDetails(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    validateAdminTokenFromEmail(request: any){
      return this.http.post<any>(this.dtfService.validateAdminTokenFromEmail(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    prepareToSaveAdminNewPassword(request: any){
      return this.http.post<any>(this.dtfService.prepareToSaveAdminNewPassword(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    // fetchEncodedInvoice(request: any){
    //   return this.http.post<any>(this.dtfService.fetchEncodedInvoice(), request,{ headers: this.dtfService.getHttpHeaders() });
    // }

    fetchEncodedInvoiceList(request: any){
      return this.http.post<any>(this.dtfService.fetchEncodedInvoiceList(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    // getInvoiceDetailsUnEncoded(request: any){
    //   return this.http.post<any>(this.dtfService.getInvoiceDetailsUnEncoded(), request,{ headers: this.dtfService.getHttpHeaders() });
    // }

     fetchInvoiceDetailsfromDB(request: any){
       return this.http.post<any>(this.dtfService.fetchInvoiceDetailsfromDB(), request,{ headers: this.dtfService.getHttpHeaders() });
     }

    retrieveInterestLetter(request: any){
      return this.http.post<any>(this.dtfService.retrieveInterestLetter(), request,{ headers: this.dtfService.getHttpHeaders() });
    }  
    adminretrieveInterestLetter(request: any){
      return this.http.post<any>(this.dtfService.adminretrieveInterestLetter(), request,{ headers: this.dtfService.getHttpHeaders() });
    }  
    clearSessionData(request: any) {
      return this.http.post<any>(this.dtfService.clearSessionData(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    getUser(request: any) {
      return this.http.post<any>(this.dtfService.getUser(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    getDocumentList(request: any) {
      return this.http.post<any>(this.dtfService.getDocumentList(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    getCounties(request: any) {
      return this.http.post<any>(this.dtfService.getCounties(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    getStates(request: any) {
      return this.http.post<any>(this.dtfService.getStates(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    getPasswordResetStepOne(request: any) {
      return this.http.post<any>(this.dtfService.getPasswordResetStepOne(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    updateEmailPreferences(request: any) {
      return this.http.post<any>(this.dtfService.updateEmailPreferences(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    fetchEbillFlagForUser(request: any) {
      return this.http.post<any>(this.dtfService.fetchEbillFlagForUser(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    saveEnrollOrCancelOptionToALFA(request: any) {
      return this.http.post<any>(this.dtfService.saveEnrollOrCancelOptionToALFA(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    validateTokenFromEmail(request: any) {
      return this.http.post<any>(this.dtfService.validateTokenFromEmail(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    
    prepareToSaveNewPassword(request: any) {
      return this.http.post<any>(this.dtfService.prepareToSaveNewPassword(), request, { headers: this.dtfService.getHttpHeaders() });
    }
 verifyUserId(request: any) {
      return this.http.post<any>(this.dtfService.verifyUserId(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    submitCCPA(request: any) {
      return this.http.post<any>(this.dtfService.submitCCPA(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    prepareToRegisterUser(request: any) {
      return this.http.post<any>(this.dtfService.prepareToRegisterUser(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    prepareAccountSetup(request: any) {
      return this.http.post<any>(this.dtfService.prepareAccountSetup(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    deleteUser(request: any) {
      return this.http.post<any>(this.dtfService.deleteUser(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    updateAndSendEmailToUser(request: any) {
      return this.http.post<any>(this.dtfService.updateAndSendEmailToUser(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    getlistAllPaymentsForSchedule(request: any) {
      return this.http.post<any>(this.dtfService.getlistAllPaymentsForSchedule(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    emailverification(request: any) {
      return this.http.post<any>(this.dtfService.emailverification(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    getTerminationQuoteByVin(request: any) {
      return this.http.post<any>(this.dtfService.getTerminationQuoteByVin(), request, { headers: this.dtfService.getHttpHeaders() });
    } 
     //olp
    getCustomerDetails(request: any){
      return this.http.post<any>(this.dtfService.getCustomerDetails(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    getODSThirdPartyAccountSummary(request: any) {
      return this.http.post<any>(this.dtfService.getODSThirdPartyAccountSummary(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    getBankName(request: any) {
      return this.http.post<any>(this.dtfService.getBankName(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    validateBank(request: any) {
      return this.http.post<any>(this.dtfService.validateBank(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    bankProfile(request: any) {
      return this.http.post<any>(this.dtfService.bankProfile(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    saveProfile(request: any) {
      return this.http.post<any>(this.dtfService.saveProfile(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    updateProfile(request: any) {
      return this.http.post<any>(this.dtfService.updateProfile(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    deleteProfile(request: any) {
      return this.http.post<any>(this.dtfService.deleteProfile(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    getInvoiceList(request: any) {
      return this.http.post<any>(this.dtfService.getInvoiceList(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    orders(request: any) {
      return this.http.post<any>(this.dtfService.orders(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    subscriptions(request: any) {
      return this.http.post<any>(this.dtfService.subscriptions(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    subscriptionsList(request: any) {
      return this.http.post<any>(this.dtfService.subscriptionsList(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    cancelSubscription(request: any) {
      return this.http.post<any>(this.dtfService.cancelSubscription(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    guestPayPayment(request: any) {
      return this.http.post<any>(this.dtfService.guestPayPayment(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    getAgreementAssetDetail(request: any) {
      return this.http.post<any>(this.dtfService.getAgreementAssetDetail(), request, { headers: this.dtfService.getHttpHeaders() });
    }   
    getMultiAgreementAssetDetail(request: any) {
      return this.http.post<any>(this.dtfService.getMultiAgreementAssetDetail(), request, { headers: this.dtfService.getHttpHeaders() });
    }  
    getVinDetails(request: any) {
      return this.http.post<any>(this.dtfService.getVinDetails(), request, { headers: this.dtfService.getHttpHeaders() });
    } 
    getMultiPayoff(request: any) {
      return this.http.post<any>(this.dtfService.getMultiPayoff(), request, { headers: this.dtfService.getHttpHeaders() });
    }   
    viewPayoff(request: any) {
      return this.http.post<any>(this.dtfService.viewPayoff(), request, { headers: this.dtfService.getHttpHeaders() });
    }  
    listliveAndExpiredQuotes(request: any) {
      return this.http.post<any>(this.dtfService.listliveAndExpiredQuotes(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    encryptCTR(request: any) {
      return this.http.post<any>(this.dtfService.encryptCTR(), request, { headers: this.dtfService.getHttpHeaders() });
    }  
     
    decryptCTR(request: any) {
      return this.http.post<any>(this.dtfService.decryptCTR(), request, { headers: this.dtfService.getHttpHeaders() });
    }   
    
    getCalculator(request: any) {
      return this.http.post<any>(this.dtfService.getCalculator(), request, { headers: this.dtfService.getHttpHeaders() });
    }   

    isPcAutopayEnabled(request: any) {
      return this.http.post<any>(this.dtfService.isPcAutopayEnabled(), request, { headers: this.dtfService.getHttpHeaders() });
    }   
    getValidAutopayAccounts(request: any) {
      return this.http.post<any>(this.dtfService.getValidAutopayAccounts(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    verifyAccountNumber(request: any) {
      return this.http.post<any>(this.dtfService.verifyAccountNumber(), request, { headers: this.dtfService.getHttpHeaders() });
    }   
    getRoutingNumber(request: any) {
      return this.http.post<any>(this.dtfService.getRoutingNumber(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    getBankProfileDetailsforAutopayAccounts(request: any) {
      return this.http.post<any>(this.dtfService.getBankProfileDetailsforAutopayAccounts(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    setAutoPayAndBankProfile(request: any) {
      return this.http.post<any>(this.dtfService.setAutoPayAndBankProfile(), request, { headers: this.dtfService.getHttpHeaders() });
    }    
    editAutoPayAndBankProfile(request: any) {
      return this.http.post<any>(this.dtfService.editAutoPayAndBankProfile(), request, { headers: this.dtfService.getHttpHeaders() });
    }
    deleteAutoPayAndBankProfile(request: any) {
      return this.http.post<any>(this.dtfService.deleteAutoPayAndBankProfile(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    contractAndtitleStateTransfer(request: any) {
      return this.http.post<any>(this.dtfService.contractAndtitleStateTransfer(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    changeOfAddress(request: any) {
      return this.http.post<any>(this.dtfService.changeOfAddress(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    setTitleAuthorization(request: any) {
      return this.http.post<any>(this.dtfService.setTitleAuthorization(), request, { headers: this.dtfService.getHttpHeaders() });
    }

    fetchAdminInvoiceDetailsfromDB(request: any){
      return this.http.post<any>(this.dtfService.fetchAdminInvoiceDetailsfromDB(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    saveLineItemFlag(request: any){
      return this.http.post<any>(this.dtfService.saveLineItemFlag(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    
    fetchAdminEncodedInvoiceList(request: any){
      return this.http.post<any>(this.dtfService.fetchAdminEncodedInvoiceList(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    validateAddress(request: any){
      return this.http.post<any>(this.dtfService.validateAddress(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    
    forgotUserId(request: any){
      return this.http.post<any>(this.dtfService.forgotUserId(), request,{ headers: this.dtfService.getHttpHeaders() });
    }

    dynamicAddendum(request: any){
      return this.http.post<any>(this.dtfService.dynamicAddendum(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    
    fetchDynamicAddendumAssetHistory(request: any){
      return this.http.post<any>(this.dtfService.fetchDynamicAddendumAssetHistory(), request,{ headers: this.dtfService.getHttpHeaders() });
    }
    
    isAuthenticated() {
      this.isAuth = sessionStorage.getItem('auth');
      if (this.isAuth !== null && this.isAuth === 'yes') {
        this.setisAuth();
      } else {
        this.setisFalse();
      }
    }

    isAdminAuthenticated() {
      this.isAdminAuth = sessionStorage.getItem('adminauth');
      if (this.isAdminAuth !== null && this.isAdminAuth === 'yes') {
        this.setisAdminAuth();
      } else {
        this.setisAdminFalse();
      }
    }

    isLoginAttempt(bool) {
      if (bool) {
       sessionStorage.setItem('loginAttempt', 'true');
      }
    }
    isLoginForwardAttempt(bool) {
      if (bool) {
       sessionStorage.setItem('loginForwardAttempt', 'true');
      }
    }

    public SetObjData(newValue: ContractNumberRequest[]): void {
      this._contractList.next(Object.assign([], newValue));
    }

    public SetErrorMessage(errorMessage: string): void {
      this._isErrorMessage.next(errorMessage);
    }

    public SetTerminationDate(terminationDate: string): void {
      this._terminationDate.next(terminationDate);
    }

    public SetAddressData(address: AddressRequest[]): void {
      this._address.next(Object.assign([], address));
    }

    private handleError(error: HttpErrorResponse) {
    if (error.status === 404) {
      return throwError(() => 'We could not find anything matching with the requested resource.');
    }
      return throwError(() => error.error.message || 'Your request cannot be processed. Please try again later.');
    }

    setisAuth() {
      this._isAuth.next(true);
    }

    setisFalse() {
      this._isAuth.next(false);
    }

    setisAdminAuth() {
      this._isAdminAuth.next(true);
    }

    setisAdminFalse() {
      this._isAdminAuth.next(false);
    }

    
}
